import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/profile-dashboard-image.png'


const _withScopeId = n => (_pushScopeId("data-v-3da9cc8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-flex tw-flex-col tw-pt-6 tw-border-t-dashed-custom" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "tw-w-full tw-flex tw-flex-col tw-gap-4 tw-pt-6 tw-border-t-dashed-custom"
}
const _hoisted_4 = {
  key: 0,
  class: "contractor-list tw-w-full tw-grid tw-gap-3"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "member_img tw-w-[35px] tw-max-w-full tw-h-[35px] tw-rounded-full" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "tw-w-full tw-h-full tw-object-cover",
    alt: ""
  })
], -1))
const _hoisted_7 = {
  key: 1,
  class: "tw-w-full tw-flex tw-items-center tw-justify-center"
}
const _hoisted_8 = { class: "tw-w-full tw-flex tw-items-center tw-justify-end tw-pt-6 tw-box-border tw-border-t-dashed-custom tw-gap-4" }

import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { USER_STORE } from "@/store/modules/user";
import { UserRolesEnum } from "@/core/enums/RolesEnum";


export default /*#__PURE__*/_defineComponent({
  __name: 'DSPProjectDetailModal',
  props: {
  estimateData: {
    type: Object,
    default: null,
  },
  phaseData: {
    type: Object,
    default: null,
  },
},
  emits: ["close", "continue", "clearphaseData"],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const props = __props;
const store = useStore();
const disputeForm = ref(null) as any;
const selectedPhases = ref([]) as any;
const disputeType = ref("project");
const selectedContractorIds = ref([]) as any;
const escrowAccount = ref();

const toggleSelection = (id: number) => {
  const selectedIndex = selectedContractorIds.value.indexOf(id);
  if (selectedContractorIds.value.includes(id)) {
    selectedContractorIds.value.splice(selectedIndex, 1);
  } else {
    selectedContractorIds.value.push(id);
  }
  console.log(selectedContractorIds.value, "selectedContractorIds");
  // const selectedIndex = selectedContractorIds.value.indexOf(id);
  // if (selectedIndex === -1) {
  //   selectedContractorIds.value.push(id);
  // } else {
  //   selectedContractorIds.value.splice(selectedIndex, 1);
  // }
};
const isSelected = (id: number) => {
  return selectedContractorIds.value.includes(id);
};
const disputeProjectFormRules = ref({
  disputeType: [
    (value: string) => !!value || "Please select the dispute type.",
  ],
  validatePhases: [
    (value: any[]) =>
      disputeType.value !== "phases" ||
      (value && value.length > 0) ||
      "Please select at least one phase.",
  ],
});

const user = computed(() => store.getters[`${USER_STORE}/user`]);

const estimatePhases = computed(() => {
  let phases = [] as any;

  const raiseDisputePhase = props?.phaseData;

  if (raiseDisputePhase) {
    if (
      raiseDisputePhase.escrowStatus &&
      raiseDisputePhase.escrowStatus.name === "Stage Complete"
    ) {
      phases.push(raiseDisputePhase);
    }
  } else {
    props.estimateData?.estimationPhase.forEach((phase: any) => {
      if (phase.phaseType === 1) {
        console.log("Escrow Sttaus", phase);
        if (
          phase.escrowStatus &&
          phase.escrowStatus.name === "Stage Complete"
        ) {
          phases.push(phase);
        }
      }
    });
  }

  return phases;
});

const isPropertyOwner = computed(() => {
  return user.value?.role?.name === UserRolesEnum.PROPERTY_OWNER;
});

const contractorList = computed(() => {
  const initialContractors = props.estimateData?.inviteContractors.map(
    (contractor: any) => contractor?.toContractorWorkstation
  );

  const mainContractor = props.estimateData?.workStation;

  if (
    mainContractor &&
    !initialContractors.some(
      (contractor: any) => contractor.id === mainContractor.id
    )
  ) {
    initialContractors.push(mainContractor);
    selectedContractorIds.value.push(mainContractor.id);
  }

  return initialContractors;
});

const onClickCloseButton = () => {
  emits("close");
};
const formatPhaseTitle = (phase: any) => {
  return `Phase-${phase.phaseOrder + 1}: ${phase.name}`;
};

const onContinueDisputeProject = async () => {
  const isFormValid = await disputeForm.value.validate();

  if (!isFormValid.valid) return;

  emits("continue", {
    phases: selectedPhases.value,
    contractorIds: selectedContractorIds.value,
  });
};

onMounted(() => {
  const raiseDisputePhase = props?.phaseData;

  if (raiseDisputePhase) {
    disputeType.value = "phases";
    selectedPhases.value.push(raiseDisputePhase.id);
  }
});
onUnmounted(() => {
  emits("clearphaseData");
});

return (_ctx: any,_cache: any) => {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    isShowCloseButton: true,
    isShowHeader: true,
    isTitleStrong: true,
    headerTitle: "Phases & Contractors",
    headerDescription: "Please help us understand which part of the project & which trade contractor are you referring to by selecting all that apply.",
    headerDescriptionTextSize: "h6",
    headerDescriptionLineHeight: "20px",
    width: "655px",
    maxWidth: "100%"
  }, {
    body: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createVNode(_component_v_form, {
          ref_key: "disputeForm",
          ref: disputeForm,
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
          rules: disputeProjectFormRules.value,
          class: "tw-pb-4"
        }, {
          default: _withCtx(() => [
            _createVNode(Text, {
              variant: "h5",
              textWeight: "18px"
            }, {
              default: _withCtx(() => [
                _createTextVNode("The dispute is related to:")
              ]),
              _: 1
            }),
            _createVNode(_component_v_radio_group, {
              modelValue: disputeType.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((disputeType).value = $event)),
              rules: disputeProjectFormRules.value.disputeType
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_radio, {
                  label: "The Whole Project",
                  value: "project"
                }),
                _createVNode(_component_v_radio, {
                  label: "Phases",
                  value: "phases"
                }),
                (disputeType.value === 'phases')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_v_select, {
                        rules: disputeProjectFormRules.value.validatePhases,
                        density: "compact",
                        variant: "outlined",
                        modelValue: selectedPhases.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPhases).value = $event)),
                        items: estimatePhases.value,
                        "item-title": formatPhaseTitle,
                        "item-value": "id",
                        label: "Select Phases",
                        multiple: "",
                        dense: "",
                        "hide-details": "",
                        "no-data-text": "No completed phases available."
                      }, null, 8, ["rules", "modelValue", "items"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "rules"])
          ]),
          _: 1
        }, 8, ["rules"]),
        (isPropertyOwner.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(Text, {
                variant: "h5",
                textWeight: "18px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("I have concerns with the following trade contractor:")
                ]),
                _: 1
              }),
              (contractorList.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractorList.value, (contractor, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        onClick: ($event: any) => (toggleSelection(contractor?.id)),
                        key: index,
                        class: _normalizeClass(["tw-rounded-[8px] tw-border-[1px] tw-border-solid tw-border-[#DFDFDF] tw-bg-[#F8FBFD] tw-w-full tw-p-2 tw-h-[55px] tw-box-border tw-flex tw-items-center tw-gap-2", {
                '!tw-border-[#3366FF] !tw-bg-[rgba(51,102,255,0.06)]':
                  isSelected(contractor?.id),
              }])
                      }, [
                        _hoisted_6,
                        _createVNode(Text, {
                          variant: "span",
                          textWeight: "400"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(contractor.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ], 10, _hoisted_5))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(Text, null, {
                      default: _withCtx(() => [
                        _createTextVNode("No Available Contractors")
                      ]),
                      _: 1
                    })
                  ]))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("section", _hoisted_8, [
        _createVNode(Button, {
          class: "!tw-w-auto",
          variant: "secondary",
          label: "Cancel",
          onClick: onClickCloseButton
        }),
        _createVNode(Button, {
          class: "!tw-w-auto",
          variant: "accent",
          label: "Continue",
          onClick: onContinueDisputeProject
        })
      ])
    ]),
    _: 1
  }))
}
}

})